// export const API_BASE_URL = "https://thaisontest.site/api";
// export const API_BASE_URL = "https://sonhai.bacninhso.com/api";
export const API_BASE_URL = "https://yendinh.bacninhso.com/api";
export const FILE_BASE_URL = `${API_BASE_URL}/file/download-file?fileKey=`;
